import { render, staticRenderFns } from "./LogoutView.vue?vue&type=template&id=1e2aac0c&scoped=true"
import script from "./LogoutView.vue?vue&type=script&lang=js"
export * from "./LogoutView.vue?vue&type=script&lang=js"
import style0 from "./LogoutView.vue?vue&type=style&index=0&id=1e2aac0c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2aac0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e2aac0c')) {
      api.createRecord('1e2aac0c', component.options)
    } else {
      api.reload('1e2aac0c', component.options)
    }
    module.hot.accept("./LogoutView.vue?vue&type=template&id=1e2aac0c&scoped=true", function () {
      api.rerender('1e2aac0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/LogoutView.vue"
export default component.exports